import { type TranslationTree } from '@/i18n/types';

export const messages = {
  accessLabel: 'Acesso ao Bodyprint Partners',
  signIn: 'Entrar',
  signUp: 'Criar conta',
} satisfies TranslationTree;
